import { atom } from 'jotai'
import type { Params } from 'next/dist/server/request/params'

export interface NavigationItem {
  page: string
  path: string
  searchParams: URLSearchParams
  pathParams: Params
}

export const navigationHistoryAtom = atom<NavigationItem[]>([])
